
import { Options, Vue } from 'vue-class-component';
import { ProviderAuthClient } from '@/services/DueDiligenceServices';
import { LoginServices } from '@/services/LoginServices';
import InfoModal from '@/components/modals/infoModal.vue';
import store from '@/store';
import { StorageServices } from '@/services/StorageServices';

@Options({})
export default class ProviderLogin extends Vue {
    supplierLabel = '';

    credential = {
        username: "",
        password: "",
        preferredCulture: "en-US"
    };

    created() {
        this.credential.preferredCulture = store.state.loggedUser?.preferredCulture || "en-US";
        const token = this.$route.query.token as string;
        if (token) ProviderAuthClient.validateInvitationToken(token).then(info => {
            if (!info.valid) return;
            this.credential.username = info.email;
            this.supplierLabel = [info.providerName, info.supplierCode, info.companyName].filter(Boolean).join(' · ');
        });
    }

    async login() {
        try {
            const auth = await ProviderAuthClient.login(this.credential);
            StorageServices.setNewTokens(auth.token, auth.refreshToken);
            const token = this.$route.query.token as string;
            const profileId = this.$route.query.profileId as string;
            let user;
            if (token) {
                const profile = await ProviderAuthClient.acceptInvitation(token);
                user = await ProviderAuthClient.switchProfile(profile.identifier);
            } else if (profileId) {
                user = await ProviderAuthClient.switchProfile(profileId);
            } else {
                user = await ProviderAuthClient.tokenUpgrade();
            }
            LoginServices.ProviderLoginCallback(user);
        } catch (err) {
            this.$opModal.show(InfoModal, {
                text: this.$localizationService.getLocalizedValue("Error", "Error"),
                subtitle: err.Message || err,
                deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                denyCb: () => { this.$opModal.closeLast(); }
            });
        }
    }

    get disabled() {
        return !this.credential.username || !this.credential.password;
    }
}
